/* @flow */
import React from 'react';

import { css } from 'glamor';

import { ZINDEX_NAVIGATION } from 'depop/styles/zIndex';

import FillHorizontal from 'depop/components/layout/FillHorizontal';

import FooterMenuItem from './FooterMenuItem';
import LocaleSwitcher from './LocaleSwitcher';
import Container from 'depop/components/layout/Container';

import AboutLink from './links/AboutLink';
import JobsLink from './links/JobsLink';
import EventsLink from './links/EventsLink';
import PressLink from './links/PressLink';
import SpacesLink from './links/SpacesLink';
import SupportLink from './links/SupportLink';
import InstagramLink from './links/InstagramLink';
import TwitterLink from './links/TwitterLink';
import FacebookLink from './links/FacebookLink';

export default class Footer extends React.PureComponent {
  render() {
    return (
      <nav
        {...css({
          display: 'block',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          margin: 0,
          background: '#fff',
          zIndex: ZINDEX_NAVIGATION,
          borderTop: '1px solid rgba(238,238,238, 1)'
        })}>
        <Container condensed>
          <FillHorizontal>
            <FooterMenuItem>
              <AboutLink />
            </FooterMenuItem>
            <FillHorizontal.Separator size={16} />
            <FooterMenuItem>
              <JobsLink />
            </FooterMenuItem>
            <FillHorizontal.Separator size={16} />
            <FooterMenuItem>
              <EventsLink />
            </FooterMenuItem>
            <FillHorizontal.Separator size={16} />
            <FooterMenuItem>
              <SpacesLink />
            </FooterMenuItem>
            <FillHorizontal.Separator size={16} />
            <FooterMenuItem>
              <SupportLink />
            </FooterMenuItem>
            <FillHorizontal.Separator size={16} />
            <FooterMenuItem>
              <InstagramLink />
            </FooterMenuItem>
            <FillHorizontal.Separator size={16} />
            <FooterMenuItem>
              <TwitterLink />
            </FooterMenuItem>
            <FillHorizontal.Separator size={16} />
            <FooterMenuItem>
              <FacebookLink />
            </FooterMenuItem>
            <FillHorizontal.Spacer size={16} />
            <LocaleSwitcher />
          </FillHorizontal>
        </Container>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/Footer.js